import React from "react";
import "./index.css";

const SMSThread = ({ SMSThread, fishPhoneNumber, inboxPhoneNumber }) => {
  return (
    <div className="no-scrollbar pb-6">
      <div className="flex flex-col space-y-2">
        {SMSThread.map((msg, index) => {
          const isInbound = !!msg.sender; // Inbound if there's a 'sender'
          // Use either receivedAt (inbound) or sentAt (outbound) for time
          const timestamp = new Date(
            msg.receivedAt || msg.sentAt
          ).toLocaleString();

          return (
            <div
              key={index}
              className={`flex ${isInbound ? "justify-start" : "justify-end"}`}
            >
              <div
                className={`rounded-lg p-2 max-w-[70%] ${
                  isInbound ? "bg-gray-200" : "bg-blue-200"
                }`}
              >
                <p className="whitespace-pre-wrap wrap-break-word">
                  {msg.messageBody}
                </p>
                <div className="text-xs text-gray-600 mt-1">
                  {timestamp} {isInbound ? fishPhoneNumber : inboxPhoneNumber}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SMSThread;
